// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Caml_obj from "@rescript/std/lib/es6/caml_obj.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import * as PhoneField from "../../../forms/PhoneField.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as FormHelpers from "../../../../utils/FormHelpers.bs.js";
import * as FormReducer from "../../../../utils/FormReducer.bs.js";
import * as $$Notification from "../../../library/Notification.bs.js";
import * as ReactHookForm from "../../../../bindings/ReactHookForm.bs.js";
import * as ErrorFieldText from "../../../forms/ErrorFieldText.bs.js";
import * as FormValidators from "../../../../forms/FormValidators.bs.js";
import * as OnboardingForms from "../../../../forms/OnboardingForms.bs.js";
import * as ReactHookForm$1 from "react-hook-form";
import * as SignUpStepStyles from "./SignUpStepStyles.bs.js";
import * as LayoutDataContext from "../../../../utils/LayoutDataContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PrezzeePublicClient from "../../../../api/PrezzeePublicClient.bs.js";
import * as Button$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Button/Button.bs.js";
import * as RichText$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/RichText/RichText.bs.js";

var invalidMsg = "Invalid phone number";

var make = React.memo(function (props) {
      var dispatch = props.dispatch;
      var stateEmail = props.stateEmail;
      var onNextBtnClick = props.onNextBtnClick;
      var match = FormReducer.useFormReducer(undefined);
      var formDispatch = match[1];
      var formState = match[0];
      var layoutData = LayoutDataContext.useContext(undefined);
      var registerData = Belt_Option.flatMap(layoutData, (function (o) {
              return o.register;
            }));
      var stepTitlePhoneNumber = Belt_Option.mapWithDefault(registerData, "<p>Last step,</p><p>What's your number so we can send you a code?</p>", (function (c) {
              return c.stepTitlePhoneNumber;
            }));
      var phoneNumberRequiredText = Belt_Option.mapWithDefault(registerData, "Phone number is required", (function (c) {
              return c.phoneNumberRequiredText;
            }));
      var invalidPhoneNumberText = Belt_Option.mapWithDefault(registerData, "Please enter a valid mobile number", (function (c) {
              return c.invalidPhoneNumberText;
            }));
      var newsletterCheckboxLabel = Belt_Option.mapWithDefault(registerData, "Yes, I'd like to be first to receive news and special offers from PREZZEE.", (function (c) {
              return c.newsletterCheckboxLabel;
            }));
      var tAndCsCheckboxLabel = Belt_Option.mapWithDefault(registerData, "\n          By continuing, you agree to Prezzee's\n          <a\n            target='_blank'\n            href='/policies/privacy-policy/'>\n            Privacy Policy\n          </a>\n           and\n          <a\n            target='_blank'\n            href='/policies/terms-of-service/'>\n            Terms of Services.\n          </a>\n    ", (function (c) {
              return c.tAndCsCheckboxLabel;
            }));
      var nzNotPrezzyDisclaimer = Belt_Option.mapWithDefault(registerData, "By continuing I acknowledge and understand that \"Prezzee\" is not affiliated or associated in any way with \"PREZZY®\", \"PREZZY® Card\" or EPAY NEW ZEALAND LIMITED (NZBN 9429036203420) and PREZZY® is a registered trade mark of Epay New Zealand Limited\"", (function (c) {
              return c.nzNotPrezzyDisclaimer;
            }));
      var sendSecurityCodeCtaText = Belt_Option.mapWithDefault(registerData, "Send SMS verification code", (function (c) {
              return c.sendSecurityCodeCtaText;
            }));
      var form = ReactHookForm.useForm({
            mode: "onSubmit",
            reValidateMode: "onSubmit",
            defaultValues: {
              phoneNumber: null,
              marketingOptIn: Caml_obj.notequal(Util.EnvUtil.getCountry(undefined), {
                    TAG: /* Ok */0,
                    _0: /* GreatBritain */1
                  }),
              nzTnC: Caml_obj.notequal(Util.EnvUtil.getCountry(undefined), {
                    TAG: /* Ok */0,
                    _0: /* NewZealand */3
                  }),
              prezzeeTnC: false
            }
          }, undefined);
      var phoneControllerOptions = FormHelpers.getPhoneControllerOptions(form.control, "phoneNumber", true);
      var match$1 = ReactHookForm$1.useController(phoneControllerOptions);
      var match$2 = match$1.field;
      var phoneValue = match$2.value;
      var phoneError = Belt_Option.map(Js_dict.get(form.errors, "phoneNumber"), (function (param) {
              if (FormHelpers.getPhoneNumber(phoneValue) === "") {
                return phoneNumberRequiredText;
              } else {
                return invalidPhoneNumberText;
              }
            }));
      var onSubmit = React.useCallback((function (data) {
              Curry._1(formDispatch, /* Submit */0);
              var phoneNumber = FormHelpers.getPhoneNumber(data.phoneNumber);
              var email = FormHelpers.getValue(stateEmail);
              if (!(phoneNumber !== "" && email !== "")) {
                return Curry._1(formDispatch, /* Error */{
                            _0: invalidMsg
                          });
              }
              var phoneNumberStr = "+" + FormValidators.getCleanPhoneNumber(phoneNumber);
              Js_promise.then_((function (result) {
                      if (result.TAG !== /* Ok */0) {
                        return Promise.resolve(Curry._1(formDispatch, /* Error */{
                                        _0: invalidMsg
                                      }));
                      }
                      Curry._1(dispatch, {
                            TAG: /* Step4Update */3,
                            phoneNumber: phoneNumberStr,
                            marketingOptIn: data.marketingOptIn
                          });
                      return Promise.resolve(Curry._1(onNextBtnClick, undefined));
                    }), PrezzeePublicClient.securityCode({
                        email: email,
                        phoneNumber: phoneNumberStr
                      }));
            }), [
            dispatch,
            stateEmail
          ]);
      var e = formState.error;
      return JsxRuntime.jsxs("form", {
                  children: [
                    e !== undefined ? JsxRuntime.jsx($$Notification.make, {
                            notificationType: /* NotificationError */0,
                            title: "An error occured",
                            description: e
                          }) : null,
                    JsxRuntime.jsx("label", {
                          children: JsxRuntime.jsx(RichText$PrezzeeRibbon.make, {
                                children: stepTitlePhoneNumber
                              }),
                          className: SignUpStepStyles.formLabel
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(PhoneField.TSXComponent.make, {
                                error: Belt_Option.getWithDefault(phoneError, ""),
                                fieldOnBlur: match$2.onBlur,
                                fieldOnChange: match$2.onChange
                              }),
                          className: "text-left"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("label", {
                                children: [
                                  JsxRuntime.jsx("input", {
                                        ref: Caml_option.some(Curry._1(form.register, OnboardingForms.marketingOptInInput)),
                                        className: "form-checkbox text-prezzee-red border-2 border-gray-300 h-6 w-6",
                                        name: "marketingOptIn",
                                        type: "checkbox"
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: Util.ReactStuff.s(newsletterCheckboxLabel),
                                        className: "ml-2"
                                      })
                                ],
                                className: "inline-flex items-center"
                              }),
                          className: "mt-6 w-full text-sm text-left"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("label", {
                                children: [
                                  JsxRuntime.jsx("input", {
                                        ref: Caml_option.some(Curry._1(form.register, OnboardingForms.prezzeeTnCInput)),
                                        className: "form-checkbox text-prezzee-red border-2 border-gray-300 h-6 w-6",
                                        name: "prezzeeTnC",
                                        type: "checkbox"
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: JsxRuntime.jsx(RichText$PrezzeeRibbon.make, {
                                              children: tAndCsCheckboxLabel,
                                              className: SignUpStepStyles.tAndCs
                                            }),
                                        className: "ml-2"
                                      })
                                ],
                                className: "inline-flex items-center"
                              }),
                          className: "mt-4 w-full text-sm text-left"
                        }),
                    JsxRuntime.jsx(ErrorFieldText.make, {
                          error: FormHelpers.getFieldError(form.errors, "prezzeeTnC")
                        }),
                    Caml_obj.equal(Util.EnvUtil.getCountry(undefined), {
                          TAG: /* Ok */0,
                          _0: /* NewZealand */3
                        }) ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("label", {
                                          children: [
                                            JsxRuntime.jsx("input", {
                                                  ref: Caml_option.some(Curry._1(form.register, OnboardingForms.nzTnCInput)),
                                                  className: "form-checkbox text-prezzee-red border-2 border-gray-300 h-6 w-6",
                                                  name: "nzTnC",
                                                  type: "checkbox"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: JsxRuntime.jsx(RichText$PrezzeeRibbon.make, {
                                                        children: nzNotPrezzyDisclaimer
                                                      }),
                                                  className: "ml-2 text-link-blue"
                                                })
                                          ],
                                          className: "inline-flex items-center"
                                        }),
                                    className: "mt-4 w-full text-xs text-left"
                                  }),
                              JsxRuntime.jsx(ErrorFieldText.make, {
                                    error: FormHelpers.getFieldError(form.errors, "nzTnC")
                                  })
                            ]
                          }) : null,
                    JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                          children: JsxRuntime.jsx("button", {
                                children: Util.ReactStuff.s(sendSecurityCodeCtaText),
                                className: SignUpStepStyles.submitBtn,
                                disabled: formState.isSubmitting,
                                type: "submit"
                              })
                        })
                  ],
                  onSubmit: Curry._2(form.handleSubmit, onSubmit, FormHelpers.onError)
                });
    });

export {
  invalidMsg ,
  make ,
}
/* make Not a pure module */
